import React from 'react'
import styled from 'styled-components'
import { DROPDOWN_COPYTRADING_TRADERS_BACKGROUND_URL } from '../../DropdownCopytrading/components/DropdownCopytradingTopTraders/constants'
import { DropdownCopytradingTopTradersItem } from '../../DropdownCopytradingTopTradersItem'
import { CopytradingTopTradersMobileListProps } from './types'

export const CopytradingTopTradersMobileList = (props: CopytradingTopTradersMobileListProps) => {
  const { traders } = props

  return (
    <StyledCopytradingTopTradersMobileList>
      {traders.slice(0, 3).map((trader, index) => {
        return (
          <DropdownCopytradingTopTradersItem
            key={trader.id}
            account={trader}
            backgroundUrl={DROPDOWN_COPYTRADING_TRADERS_BACKGROUND_URL[index]}
          />
        )
      })}
    </StyledCopytradingTopTradersMobileList>
  )
}

const StyledCopytradingTopTradersMobileList = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`
